import moment from 'moment'
import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'

const AwardedDetailModal = (props) => {
    const { show, handleClose, data } = props
    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => handleClose()}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Modal.Header className='px-0'>
                <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                    Awarded Point Details
                </Modal.Title>
                <button className="modal-close-btn me-4 text-center" onClick={handleClose}>
                    <ImCross color='#fff' size={12} />
                </button>
            </Modal.Header>
            <Modal.Body className='px-4 justify-content-center'>
                <Row className='mb-3'>
                    <Col md={4}>
                        <div className='modal-small-heading'>Logo</div>
                        <img className="img-fluid" src={require('../../../assets/images/icons/side-nav-logo.png')} width={150} />
                        <div className="modal-detail-value">{ }</div>
                    </Col>

                    <Col md={4}>
                        <div className='modal-small-heading'>Route Name</div>
                        <div className="modal-detail-value">{data?.transit_type}</div>
                    </Col>

                    <Col md={4}>
                        <div className='modal-small-heading'>Commuter Name</div>
                        <div className="modal-detail-value">{data?.commuter?.name}</div>
                    </Col>

                    <Col md={4} className="mt-4">
                        <div className='modal-small-heading'>Point Spent</div>
                        <div className="modal-detail-value">{data?.points_earned}</div>
                    </Col>

                    <Col md={4} className="mt-4">
                        <div className='modal-small-heading'>Time Stamp</div>
                        <div className="modal-detail-value">{moment(data?.started_at).format("MM-DD-YYYY, h:mm a")}</div>
                    </Col>

                </Row>


            </Modal.Body>
        </Modal>
    )
}

export default AwardedDetailModal